import styled from '@emotion/styled';

import { ReactElement, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import MainContents from '../../components/Home/MainContents';
import NavigationBar from '../../components/Home/NavigationBar';
import { useStorage } from '../../hooks/useStorage';
import AccessBottomSheet from '../AccessBottomSheet';

function Home(): ReactElement {
  const [openInfoBoxToolTip] = useStorage('openInfoBoxToolTip', false);
  const formMathods = useForm({
    defaultValues: {
      openInfoBoxToolTip: openInfoBoxToolTip,
    },
  });

  const [isMember, setIsMember] = useState(false);

  return (
    <Wrapper>
      <FormProvider {...formMathods}>
        <NavigationBar />
        <MainContents />
        <AccessBottomSheet open={!isMember} setOpen={setIsMember} />
      </FormProvider>
    </Wrapper>
  );
}

export type TabHandlerProps = {
  tab: number;
  setTab: (tab: number) => void;
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  overflow: hidden;
`;

export default Home;
